module.exports = __webpack_public_path__ + "img/Group 960.0c5a4e39.svg";